export const SeverityLevelMap = {
    '-': 'level-0',
    superficial: 'level-0',
    low: 'level-3',
    mid: 'level-4',
    high: 'level-5'
};
export const SeverityOrder = ['high', 'mid', 'low', 'superficial', '-'];
